var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:{box_shadow: _vm.box_shadow}},[_c('loader-icon',{attrs:{"size":100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }